import React, { useState } from 'react';
import { useStoreState } from 'easy-peasy';
import { Alert } from 'react-bootstrap';

const ActivityStatusModal = () => {

    const { apiData: { BACKOFFICE_DEFAULT_VALUES } } = useStoreState(state => state.actionSlugs);
    const { activityStatus } = BACKOFFICE_DEFAULT_VALUES;

    const [statusSelected, setStatusSelected] = useState();

    const generateAlert = () => {
        switch (statusSelected) {
            case "draft":
                return "En passant cette activité en brouillon, celle-ci ne sera plus visible par les utilisateur⋅rices"
            case "preprod":
                return <span>Avec ce statut l'activité sera accessible seulement sur la preprod de la webapp (<a href="https://faucon.metiers360.com/" target="blank">faucon.metiers360.com</a>)</span>
            case "lab":
                return "Avec ce statut l'activité sera accessible uniquement aux utilisateur⋅rices faisant partie du Lab"
            case "prod":
                return <span>Attention, en production, l'activité peut être accessible par tous les utilisateur⋅rices, sur le BO ou la webapp (<a href="https://webapp.metiers360.com/" target="blank">webapp.metiers360.com</a>)</span>
            default:
                return "Veuillez sélectionner un statut"
        }
    }

    return (
        <>
            <div className="squares-zone">
                {
                    activityStatus?.map(st => <div className={`status-square ${st.value} clickable ${statusSelected == st.value ? "selected" : ""}`} key={st.value} onClick={() => setStatusSelected(st.value)}>{st.label}</div>)
                }
            </div>
            <Alert variant="danger">{generateAlert()}</Alert>
            <input type="hidden" value={statusSelected || ""} id="statusSelected" />
        </>)
}

export default ActivityStatusModal